(() => {

  function initPNW2027(root) {

    if (!root || root.dataset.pnw27Ready === 'true') {
      return;
    }

    root.dataset.pnw27Ready = 'true';


    const formatUSD = (cents) => {

      const amount = Number(cents || 0) / 100;

      return new Intl.NumberFormat(
        'en-US',
        {
          style: 'currency',
          currency: 'USD'
        }
      ).format(amount);

    };


    const shortCode = () => {

      const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';

      let value = 'SG-';

      for (let i = 0; i < 6; i++) {
        value += chars[
          Math.floor(Math.random() * chars.length)
        ];
      }

      return value;

    };


    const addToCart = async (item) => {

      const response = await fetch(
        '/cart/add.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [item]
          })
        }
      );

      if (!response.ok) {

        let message =
          'Unable to add this registration to your cart.';

        try {
          const payload = await response.json();

          if (payload.description) {
            message = payload.description;
          }
        } catch (_) {}

        throw new Error(message);

      }

      window.location.href = '/cart';

    };


    /* ========================================================
       SMOOTH ANCHORS
    ======================================================== */

    root
      .querySelectorAll('a[href^="#"]')
      .forEach((link) => {

        link.addEventListener('click', (event) => {

          const href =
            link.getAttribute('href');

          if (!href || href === '#') {
            return;
          }

          const target =
            document.querySelector(href);

          if (!target) {
            return;
          }

          event.preventDefault();

          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });

        });

      });


    /* ========================================================
       COMPETITOR REGISTRATION
    ======================================================== */

    const compVariant =
      root.querySelector(
        '[data-pnw27-comp-variant]'
      );

    const registrationMode =
      root.querySelector(
        '[data-pnw27-registration-mode]'
      );

    const registerButton =
      root.querySelector(
        '[data-pnw27-register-button]'
      );

    const compTotal =
      root.querySelector(
        '[data-pnw27-comp-total]'
      );

    const compNote =
      root.querySelector(
        '[data-pnw27-comp-note]'
      );

    const compStock =
      root.querySelector(
        '#pnw27-buy [data-pnw27-stock]'
      );

    const modal =
      root.querySelector(
        '[data-pnw27-reg-modal]'
      );

    const modalTitle =
      root.querySelector(
        '[data-pnw27-reg-title]'
      );

    const modalCopy =
      root.querySelector(
        '[data-pnw27-reg-copy]'
      );

    const modalFields =
      root.querySelector(
        '[data-pnw27-reg-fields]'
      );

    const modalCancel =
      root.querySelector(
        '[data-pnw27-reg-cancel]'
      );

    const modalSubmit =
      root.querySelector(
        '[data-pnw27-reg-submit]'
      );


    const fieldTemplate = (
      name,
      label,
      type = 'text',
      required = true,
      placeholder = ''
    ) => {

      return `
        <div class="pnw27-reg-field">
          <label for="${name}">
            ${label}${required ? ' *' : ''}
          </label>

          <input
            id="${name}"
            name="${name}"
            type="${type}"
            ${required ? 'required' : ''}
            placeholder="${placeholder}"
          >
        </div>
      `;

    };


    const getField = (name) => {

      return (
        modalFields
          ?.querySelector(
            `[name="${name}"]`
          )
          ?.value
        || ''
      ).trim();

    };


    const syncCompetitorCard = () => {

      if (!compVariant) {
        return;
      }

      const option =
        compVariant.options[
          compVariant.selectedIndex
        ];

      if (!option) {
        return;
      }

      const price =
        Number(option.dataset.priceCents || 0);

      const title =
        option.dataset.variantTitle || '';

      const available =
        option.dataset.available === 'true';

      const managed =
        Boolean(
          option.dataset.inventoryManagement
        );

      const deny =
        option.dataset.inventoryPolicy === 'deny';

      const inventory =
        Number.parseInt(
          option.dataset.inventory || '',
          10
        );


      if (compTotal) {
        compTotal.textContent =
          formatUSD(price);
      }


      if (compNote) {

        if (
          title.toLowerCase().includes('both')
        ) {

          compNote.textContent =
            'This pass includes one Urban and one Summer 2027 competitor registration for each person purchased.';

        } else {

          compNote.textContent =
            'This pass includes one competitor registration for the selected 2027 event.';

        }

      }


      if (registerButton) {
        registerButton.disabled = !available;
        registerButton.textContent =
          available
            ? 'CONTINUE REGISTRATION'
            : 'SOLD OUT';
      }


      if (compStock) {

        if (
          managed &&
          deny &&
          Number.isFinite(inventory)
        ) {

          compStock.textContent =
            available
              ? `${inventory} spots remaining`
              : 'Sold out';

        } else {

          compStock.textContent =
            available
              ? 'Available'
              : 'Sold out';

        }

      }

    };


    const closeModal = () => {

      if (!modal) {
        return;
      }

      modal.hidden = true;
      modal.setAttribute(
        'aria-hidden',
        'true'
      );

      if (modalFields) {
        modalFields.innerHTML = '';
      }

    };


    const openModal = () => {

      if (
        !modal ||
        !registrationMode ||
        !modalFields
      ) {
        return;
      }

      const mode =
        registrationMode.value;


      const modes = {

        solo: {
          title:
            'Individual Registration',
          copy:
            'Enter the competitor’s contact information. We will pair this competitor with a teammate before the event.',
          button:
            'ADD INDIVIDUAL REGISTRATION',
          fields:
            ['buyer']
        },

        'team-both': {
          title:
            'Buy Two Together',
          copy:
            'Enter both competitors’ information. Both competitor passes will be added to the cart together and linked as a completed team.',
          button:
            'ADD BOTH COMPETITORS',
          fields:
            ['buyer', 'partner']
        },

        'team-start': {
          title:
            'Start a Team',
          copy:
            'Enter your information and the teammate you plan to compete with. We will generate a Team Pairing Code for their separate purchase.',
          button:
            'ADD MY REGISTRATION',
          fields:
            ['buyer', 'partner']
        },

        'team-join': {
          title:
            'Join a Team',
          copy:
            'Enter your information and the Team Pairing Code your teammate gave you.',
          button:
            'ADD MY REGISTRATION',
          fields:
            ['buyer', 'code']
        }

      };


      const cfg =
        modes[mode];

      if (!cfg) {
        return;
      }


      modalTitle.textContent =
        cfg.title;

      modalCopy.textContent =
        cfg.copy;

      modalSubmit.textContent =
        cfg.button;


      let html = '';


      if (
        cfg.fields.includes('buyer')
      ) {

        html += fieldTemplate(
          'sgBuyerName',
          'Competitor Full Name',
          'text',
          true,
          'First and last name'
        );

        html += fieldTemplate(
          'sgBuyerEmail',
          'Competitor Email',
          'email',
          true,
          'you@example.com'
        );

        html += fieldTemplate(
          'sgBuyerPhone',
          'Competitor Phone',
          'tel',
          true,
          'Phone number'
        );

      }


      if (
        cfg.fields.includes('partner')
      ) {

        html += fieldTemplate(
          'sgPartnerName',
          'Teammate Full Name',
          'text',
          true,
          'First and last name'
        );

        html += fieldTemplate(
          'sgPartnerEmail',
          'Teammate Email',
          'email',
          true,
          'teammate@example.com'
        );

        html += fieldTemplate(
          'sgPartnerPhone',
          'Teammate Phone',
          'tel',
          true,
          'Phone number'
        );

      }


      if (
        cfg.fields.includes('code')
      ) {

        html += fieldTemplate(
          'sgExistingCode',
          'Team Pairing Code',
          'text',
          true,
          'SG-ABC123'
        );

      }


      modalFields.innerHTML =
        html;

      modal.hidden = false;

      modal.setAttribute(
        'aria-hidden',
        'false'
      );

      window.setTimeout(() => {

        modalFields
          .querySelector('input')
          ?.focus();

      }, 30);

    };


    const validateModal = () => {

      const required =
        [
          ...modalFields
            .querySelectorAll(
              'input[required]'
            )
        ];


      for (
        const input of required
      ) {

        if (!input.value.trim()) {

          input.focus();

          alert(
            'Please complete all required fields.'
          );

          return false;

        }

      }


      const emailFields =
        [
          ...modalFields
            .querySelectorAll(
              'input[type="email"]'
            )
        ];


      for (
        const input of emailFields
      ) {

        if (
          input.value.trim() &&
          !input.checkValidity()
        ) {

          input.focus();

          alert(
            'Please enter a valid email address.'
          );

          return false;

        }

      }


      return true;

    };


    const submitRegistration = async () => {

      if (
        !compVariant ||
        !registrationMode
      ) {
        return;
      }


      if (!validateModal()) {
        return;
      }


      const option =
        compVariant.options[
          compVariant.selectedIndex
        ];


      const variantId =
        Number(option.value);

      const eventSelection =
        option.dataset.variantTitle || '';

      const mode =
        registrationMode.value;


      const buyerName =
        getField('sgBuyerName');

      const buyerEmail =
        getField('sgBuyerEmail');

      const buyerPhone =
        getField('sgBuyerPhone');

      const partnerName =
        getField('sgPartnerName');

      const partnerEmail =
        getField('sgPartnerEmail');

      const partnerPhone =
        getField('sgPartnerPhone');


      let quantity = 1;

      let teamMode =
        'Individual Registration';

      let pairingStatus =
        'Needs Teammate Assignment';

      let teamCode = '';

      let ticketType =
        'Individual Competitor Pass';


      if (
        mode === 'team-both'
      ) {

        quantity = 2;

        teamMode =
          'Buy Together';

        pairingStatus =
          'Team Complete';

        teamCode =
          shortCode();

        ticketType =
          'Team of 2';

      }


      if (
        mode === 'team-start'
      ) {

        teamMode =
          'Buy Separate - Starting Team';

        pairingStatus =
          'Waiting for Teammate';

        teamCode =
          shortCode();

        ticketType =
          'Team of 2';

      }


      if (
        mode === 'team-join'
      ) {

        teamMode =
          'Buy Separate - Joining Team';

        pairingStatus =
          'Joining Existing Team';

        teamCode =
          getField('sgExistingCode')
            .toUpperCase()
            .replace(/\s+/g, '');

        ticketType =
          'Team of 2';

      }


      const eventLower =
        eventSelection.toLowerCase();

      const isBothEvents =
        eventLower.includes('both');


      const properties = {

        'Ticket Info':
          isBothEvents
            ? '2027 Buy Both pass. Includes Urban and Summer registration for each competitor purchased.'
            : '2027 competitor registration.',

        'Ticket Type':
          ticketType,

        '2027 Event Selection':
          eventSelection,

        'Team Mode':
          teamMode,

        'Pairing Status':
          pairingStatus,

        'Team Pairing Code':
          teamCode,

        'Your Full Name':
          buyerName,

        'Your Email':
          buyerEmail,

        'Your Phone':
          buyerPhone,

        'Teammate Full Name':
          partnerName,

        'Teammate Email':
          partnerEmail,

        'Teammate Phone':
          partnerPhone,

        '_event_selection':
          eventSelection,

        '_team_mode':
          teamMode,

        '_team_code':
          teamCode,

        '_pairing_status':
          pairingStatus,

        '_buyer_name':
          buyerName,

        '_buyer_email':
          buyerEmail,

        '_buyer_phone':
          buyerPhone,

        '_partner_name':
          partnerName,

        '_partner_email':
          partnerEmail,

        '_partner_phone':
          partnerPhone

      };


      modalSubmit.disabled = true;

      modalSubmit.textContent =
        'ADDING...';


      try {

        await addToCart({
          id: variantId,
          quantity,
          properties
        });

      } catch (error) {

        modalSubmit.disabled = false;

        modalSubmit.textContent =
          'ADD TO CART';

        alert(error.message);

      }

    };


    if (compVariant) {

      compVariant.addEventListener(
        'change',
        syncCompetitorCard
      );

      syncCompetitorCard();

    }


    if (registerButton) {

      registerButton.addEventListener(
        'click',
        openModal
      );

    }


    if (modalCancel) {

      modalCancel.addEventListener(
        'click',
        closeModal
      );

    }


    if (modalSubmit) {

      modalSubmit.addEventListener(
        'click',
        submitRegistration
      );

    }


    if (modal) {

      modal.addEventListener(
        'click',
        (event) => {

          if (event.target === modal) {
            closeModal();
          }

        }
      );

    }


    /* ========================================================
       CAMPING PRICE
    ======================================================== */

    const campVariant =
      root.querySelector(
        '[data-pnw27-camp-variant]'
      );

    const campHiddenVariant =
      root.querySelector(
        '[data-pnw27-camp-hidden-variant]'
      );

    const campQty =
      root.querySelector(
        '[data-pnw27-camp-qty]'
      );

    const campTotal =
      root.querySelector(
        '[data-pnw27-camp-total]'
      );


    if (campQty && campTotal) {

      const syncCampPrice = () => {

        let unitCents = 0;


        if (campVariant) {

          const option =
            campVariant.options[
              campVariant.selectedIndex
            ];

          if (option) {

            unitCents =
              Number(
                option.dataset.priceCents || 0
              );

          }

        } else if (
          campHiddenVariant
        ) {

          unitCents =
            Number(
              campHiddenVariant
                .dataset
                .priceCents
              || 0
            );

        }


        const qty =
          Number(
            campQty.value || 1
          );


        campTotal.textContent =
          formatUSD(
            unitCents * qty
          );

      };


      if (campVariant) {

        campVariant.addEventListener(
          'change',
          syncCampPrice
        );

      }


      campQty.addEventListener(
        'change',
        syncCampPrice
      );


      syncCampPrice();

    }


    /* ========================================================
       MOBILE STICKY CTA
       Show only between the hero and the competitor purchase
       section. Once the shopper reaches/passes ticket purchase,
       keep it hidden so it does not cover lower-page content.
    ======================================================== */

    const mobileCTA =
      root.querySelector(
        '[data-pnw27-mobile-cta]'
      );

    const hero =
      root.querySelector(
        '.pnw27-hero'
      );

    const buy =
      root.querySelector(
        '#pnw27-buy'
      );


    if (
      mobileCTA &&
      hero &&
      buy
    ) {

      let ticking = false;


      const updateMobileCTA = () => {

        ticking = false;

        const heroBottom =
          hero.getBoundingClientRect().bottom;

        const buyTop =
          buy.getBoundingClientRect().top;

        const viewportHeight =
          window.innerHeight ||
          document.documentElement.clientHeight;


        /*
          Display after hero leaves the viewport.
          Hide shortly before the purchase area reaches view.
        */
        const shouldShow =
          heroBottom < 20 &&
          buyTop > viewportHeight * 0.72;


        mobileCTA.classList.toggle(
          'is-visible',
          shouldShow
        );

      };


      const onScroll = () => {

        if (!ticking) {

          window.requestAnimationFrame(
            updateMobileCTA
          );

          ticking = true;

        }

      };


      window.addEventListener(
        'scroll',
        onScroll,
        {
          passive: true
        }
      );


      window.addEventListener(
        'resize',
        onScroll
      );


      updateMobileCTA();

    }

  }


  document
    .querySelectorAll(
      '[data-pnw27-section]'
    )
    .forEach(initPNW2027);


  document.addEventListener(
    'shopify:section:load',
    (event) => {

      const root =
        event.target
          .querySelector(
            '[data-pnw27-section]'
          );

      if (root) {
        initPNW2027(root);
      }

    }
  );

})();
